import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ProgressBarModule as PrimeNGProgressBarModule } from 'primeng/progressbar';

@NgModule({
  declarations: [ProgressBarComponent],
  imports: [CommonModule, PrimeNGProgressBarModule],
  exports: [ProgressBarComponent],
})
export class ProgressBarModule {}
